// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_table__85kK8 {
    width: 100%;
    table-layout: fixed;
}

.styles_table__85kK8 th {
    background-color: #F5F5F5;
    border-radius: 6px;
    box-sizing: border-box;
    color: #18316e;
    padding: 0.5rem 1rem;
    position: relative;
}

.styles_table__85kK8 th,
.styles_table__85kK8 td {
    border-bottom: 1px solid #ddd;
    padding: .2rem;
    text-align: center;
    /* Remove max-width padrão para permitir larguras fixas definidas nas colunas */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Coluna Ações: não truncar título nem cortar ícones (regra acima usa ellipsis) */
.styles_table__85kK8 th.styles_colunaAcoes__ywafW,
.styles_table__85kK8 td.styles_colunaAcoes__ywafW {
    overflow: visible;
    text-overflow: clip;
    white-space: nowrap;
}

/* Estilo específico para coluna de incidência - truncamento com ellipsis */
.styles_table__85kK8 th[data-column="incidenciaRubrica"],
.styles_table__85kK8 td[data-column="incidenciaRubrica"] {
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.styles_table__85kK8 th:first-child,
.styles_table__85kK8 td:first-child {
    padding-left: 1rem;
}


.styles_tableBody__09Ls\\+ {
    border-radius: 6px;
}

.styles_btnContainer__GcpjX {
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
}

.styles_colunaAcoes__ywafW {
    box-sizing: border-box;
    vertical-align: middle;
}

/*
  table-layout: fixed + width: 1% na última coluna esmagava a célula (só “A” de Ações).
  Largura explícita + min-width garante cabeçalho e ícones.
*/
.styles_colunaAcoesIcones__bVFwy {
    min-width: 11rem;
    width: 12rem;
    padding-left: 0.35rem;
    padding-right: 0.35rem;
}

.styles_colunaAcoesUnico__9M-7a {
    min-width: 12rem;
    width: 16rem;
    max-width: min(24rem, 48vw);
    padding-left: 0.35rem;
    padding-right: 0.35rem;
}

.styles_acoesIcones__w8GVd {
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    gap: 0;
    justify-content: center;
    max-width: 100%;
    overflow-x: auto;
    padding: 0.1rem 0;
}

.styles_uniqueBtn__0Qh4o {
    align-items: center;
    background: #18316e;
    border: none;
    border-radius: 10px;
    color: #FFF;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: .3rem 1.5rem;

    &:hover {
        opacity: 0.9;
    }
}

.styles_btnAction__n5hmO {
    align-items: center;
    background-color: #18316e;
    border: none;
    border-radius: 10px;
    color: white;
    cursor: pointer;
    display: flex;
    padding: 0.3rem 1.5rem;
}

.styles_btns__rz8g2 {
    display: flex;
    justify-content: space-around;
    gap: 10px;
}

.styles_btn__eQh1N {
    align-items: center;
    background-color: white;
    border: none;
    border-radius: 4px;
    color: #18316e;
    cursor: pointer;
    display: flex;
    font-size: 1rem;
    justify-content: center;
    padding: 10px 20px;
    width: 100%;
}

.styles_btn__eQh1N span {
    margin-right: .5rem;
}

.styles_btn__eQh1N:hover {
    background-color: #F5F5F5;
}

.styles_btnPrimary__d84cK {
    background-color: #18316e;
    color: #fff;
}

.styles_btnPrimary__d84cK:hover {
    background-color: #132655;
}

.styles_btnDanger__3cW2v {
    background-color: #b71c1c;
    color: #fff;
}

.styles_btnDanger__3cW2v:hover {
    background-color: #8b0000;
}`, "",{"version":3,"sources":["webpack://./src/components/TableCardv2/TableViewv2/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,+EAA+E;IAC/E,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,kFAAkF;AAClF;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,2EAA2E;AAC3E;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;;CAGC;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,MAAM;IACN,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,qBAAqB;;IAErB;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".table {\n    width: 100%;\n    table-layout: fixed;\n}\n\n.table th {\n    background-color: #F5F5F5;\n    border-radius: 6px;\n    box-sizing: border-box;\n    color: #18316e;\n    padding: 0.5rem 1rem;\n    position: relative;\n}\n\n.table th,\n.table td {\n    border-bottom: 1px solid #ddd;\n    padding: .2rem;\n    text-align: center;\n    /* Remove max-width padrão para permitir larguras fixas definidas nas colunas */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Coluna Ações: não truncar título nem cortar ícones (regra acima usa ellipsis) */\n.table th.colunaAcoes,\n.table td.colunaAcoes {\n    overflow: visible;\n    text-overflow: clip;\n    white-space: nowrap;\n}\n\n/* Estilo específico para coluna de incidência - truncamento com ellipsis */\n.table th[data-column=\"incidenciaRubrica\"],\n.table td[data-column=\"incidenciaRubrica\"] {\n    max-width: 250px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.table th:first-child,\n.table td:first-child {\n    padding-left: 1rem;\n}\n\n\n.tableBody {\n    border-radius: 6px;\n}\n\n.btnContainer {\n    display: flex;\n    justify-content: flex-end;\n    padding-right: 1rem;\n}\n\n.colunaAcoes {\n    box-sizing: border-box;\n    vertical-align: middle;\n}\n\n/*\n  table-layout: fixed + width: 1% na última coluna esmagava a célula (só “A” de Ações).\n  Largura explícita + min-width garante cabeçalho e ícones.\n*/\n.colunaAcoesIcones {\n    min-width: 11rem;\n    width: 12rem;\n    padding-left: 0.35rem;\n    padding-right: 0.35rem;\n}\n\n.colunaAcoesUnico {\n    min-width: 12rem;\n    width: 16rem;\n    max-width: min(24rem, 48vw);\n    padding-left: 0.35rem;\n    padding-right: 0.35rem;\n}\n\n.acoesIcones {\n    align-items: center;\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 0;\n    justify-content: center;\n    max-width: 100%;\n    overflow-x: auto;\n    padding: 0.1rem 0;\n}\n\n.uniqueBtn {\n    align-items: center;\n    background: #18316e;\n    border: none;\n    border-radius: 10px;\n    color: #FFF;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    padding: .3rem 1.5rem;\n\n    &:hover {\n        opacity: 0.9;\n    }\n}\n\n.btnAction {\n    align-items: center;\n    background-color: #18316e;\n    border: none;\n    border-radius: 10px;\n    color: white;\n    cursor: pointer;\n    display: flex;\n    padding: 0.3rem 1.5rem;\n}\n\n.btns {\n    display: flex;\n    justify-content: space-around;\n    gap: 10px;\n}\n\n.btn {\n    align-items: center;\n    background-color: white;\n    border: none;\n    border-radius: 4px;\n    color: #18316e;\n    cursor: pointer;\n    display: flex;\n    font-size: 1rem;\n    justify-content: center;\n    padding: 10px 20px;\n    width: 100%;\n}\n\n.btn span {\n    margin-right: .5rem;\n}\n\n.btn:hover {\n    background-color: #F5F5F5;\n}\n\n.btnPrimary {\n    background-color: #18316e;\n    color: #fff;\n}\n\n.btnPrimary:hover {\n    background-color: #132655;\n}\n\n.btnDanger {\n    background-color: #b71c1c;\n    color: #fff;\n}\n\n.btnDanger:hover {\n    background-color: #8b0000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `styles_table__85kK8`,
	"colunaAcoes": `styles_colunaAcoes__ywafW`,
	"tableBody": `styles_tableBody__09Ls+`,
	"btnContainer": `styles_btnContainer__GcpjX`,
	"colunaAcoesIcones": `styles_colunaAcoesIcones__bVFwy`,
	"colunaAcoesUnico": `styles_colunaAcoesUnico__9M-7a`,
	"acoesIcones": `styles_acoesIcones__w8GVd`,
	"uniqueBtn": `styles_uniqueBtn__0Qh4o`,
	"btnAction": `styles_btnAction__n5hmO`,
	"btns": `styles_btns__rz8g2`,
	"btn": `styles_btn__eQh1N`,
	"btnPrimary": `styles_btnPrimary__d84cK`,
	"btnDanger": `styles_btnDanger__3cW2v`
};
export default ___CSS_LOADER_EXPORT___;
